import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-foreground-950 mt-16 md:mt-24">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-background-50">
                <i className="ri-play-fill text-2xl leading-none"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-wide">
                91<span className="text-accent-500">在线看</span>
              </span>
            </div>
            <p className="text-sm leading-7 text-foreground-600">
              91在线看是一家专注于影视资源展示的在线平台，汇集最新电影、热播剧集与经典大片，为喜爱观影的你提供便捷的搜寻与浏览体验。站内播放区域为前端演示，未接入真实播放服务。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-foreground-900">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-foreground-900">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-foreground-900">
                <i className="ri-weibo-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-foreground-800 mb-4">
              快速导航
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-foreground-600 hover:text-accent-400 transition-colors cursor-pointer">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-foreground-600 hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-foreground-800 mb-4">
              帮助与声明
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="text-foreground-600">使用说明</li>
              <li className="text-foreground-600">版权声明</li>
              <li className="text-foreground-600">意见反馈</li>
              <li className="text-foreground-600">免责声明</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 91在线看 · 本站所有资源均为演示数据，仅供学习与展示使用。</p>
          <p className="whitespace-nowrap">Powered by 91在线看 影视演示平台</p>
        </div>
      </div>
    </footer>
  );
}